import type { CrmChatProviderKey } from '@/api/types/crm/crmLeadFunnels.types'

export const getCrmIntegrationAccessDeniedTooltip = (
  provider: CrmChatProviderKey,
): string => {
  if (provider === 'vkontakte') {
    return 'У вас нет доступа к этому сообществу. Чтобы открыть чаты, обратитесь к администратору платформы.'
  }

  if (provider === 'wazzup') {
    return 'У вас нет доступа к этому аккаунту Wazzup. Чтобы открыть чаты, обратитесь к администратору платформы.'
  }

  return 'У вас нет доступа к этому боту. Чтобы открыть чаты, обратитесь к администратору платформы.'
}
